export default "__VITE_ASSET__DcE98TdL__"